(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/collections/Nodes',["backbone", "pricelist/models/Node"], function(Backbone, Node) {
    return (function(superClass) {
      extend(_Class, superClass);

      function _Class() {
        return _Class.__super__.constructor.apply(this, arguments);
      }

      _Class.prototype.model = Node;

      return _Class;

    })(Backbone.Collection);
  });

}).call(this);

//# sourceMappingURL=Nodes.js.map
;
